
class ArticleSource {
    constructor(API) {
        this.API = API;
    }


     async getArticleById(data) {
         return await this.API.get('/index.php?route=api/information', {
             params: data
         })
     }

}

export default ArticleSource
